import React, { useEffect, useState } from 'react';
import './project.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Icons
import ideaIcon from '../../assets/project-ideas.png';
import mediaIcon from '../../assets/project-media.png';
import customerIcon from '../../assets/project-happy.png';
import projectIcon from '../../assets/project-finished.png';

function Project() {
  const [counts, setCounts] = useState({
    ideas: 0,
    media: 0,
    customers: 0,
    projects: 0,
  });

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true,     // animate only once
    });

    const targets = {
      ideas: 2806,
      media: 850,
      customers: 3500,
      projects: 7456,
    };

    const speed = 30; // smaller = faster count

    const updateCounts = () => {
      setCounts((prev) => {
        let updated = { ...prev };
        Object.keys(prev).forEach((key) => {
          if (prev[key] < targets[key]) {
            updated[key] = Math.min(prev[key] + Math.ceil(targets[key] / 100), targets[key]);
          }
        });
        return updated;
      });
    };

    const interval = setInterval(updateCounts, speed);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* PROJECT STATS SECTION */}
      <div className="projectstats-section">
        <div className="container projectstats-container">

          <div className="stat-box" data-aos="fade-right">
            <img src={ideaIcon} alt="Business Ideas" />
            <h3>{counts.ideas}+</h3>
            <p>Business Ideas</p>
          </div>

          <div className="stat-box" data-aos="fade-up">
            <img src={mediaIcon} alt="Media Posts" />
            <h3>{counts.media}+</h3>
            <p>Media Posts</p>
          </div>

          <div className="stat-box" data-aos="fade-up" data-aos-delay="200">
            <img src={customerIcon} alt="Happy Customers" />
            <h3>{counts.customers}+</h3>
            <p>Happy Customers</p>
          </div>

          <div className="stat-box" data-aos="fade-left">
            <img src={projectIcon} alt="Finished Projects" />
            <h3>{counts.projects}+</h3>
            <p>Finished Projects</p>
          </div>
          
        </div>
      </div>
    </>
  );
}

export default Project;
